'use client';

import { usePathname } from 'next/navigation';
import { TMenuConfig } from '../types';

// Basic dynamic/static matcher (supports [param] or :param)
const matchPath = (pathname: any, configPath: string): boolean => {
  const pathParts: any = pathname?.split('/').filter(Boolean);
  const configParts = configPath.split('/').filter(Boolean);

  if (pathParts.length !== configParts.length) return false;

  return configParts.every((part, idx) => {
    return part.startsWith('[') || part.startsWith(':') || part === pathParts[idx];
  });
};

const useMenuChildren = (
  items: TMenuConfig,
  level: number
): TMenuConfig | null => {
  const pathname = usePathname();

  const hasActiveChild = (items: TMenuConfig): boolean => {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (item.path && matchPath(pathname, item.path)) {
        return true;
      } else if (item.children) {
        if (hasActiveChild(item.children as TMenuConfig)) {
          return true;
        }
      }
    }
    return false;
  };

  const getChildren = (
    items: TMenuConfig,
    level: number = 0,
    currentLevel: number = 0
  ): TMenuConfig | null => {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (item.children) {
        if (level === currentLevel && hasActiveChild(item.children)) {
          return item.children;
        }

        const children = getChildren(item.children, level, currentLevel + 1);
        if (children) {
          return children;
        }
      } else if (level === currentLevel && item.path && matchPath(pathname, item.path)) {
        return items;
      }
    }

    return null;
  };

  return getChildren(items, level);
};

export { useMenuChildren };
